import { render, staticRenderFns } from "./MailConfigurationform.vue?vue&type=template&id=7230db78"
import script from "./MailConfigurationform.vue?vue&type=script&lang=js"
export * from "./MailConfigurationform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports